/**
 * Centralized API endpoint paths for the SDK BFF.
 * All paths are relative to the SDK BFF base URL (resolved from SdkConfig.apiBaseUrl).
 */

export const cartEndpoints = {
  /** POST /cart/inventory - a cart for one unit already in stock. */
  inventory: 'cart/inventory',

  /** POST /cart/build-to-order - a cart for one vehicle to be built. */
  buildToOrder: 'cart/build-to-order',

  /** POST /cart/available - check vehicle availability. */
  available: 'cart/available',

  /** POST /cart - a cart named the SDK's own way. */
  create: 'cart',
} as const;
